/* Native industry selection enhances the complete static provider directory. */
(() => {
  document.querySelectorAll('[data-provider-directory]').forEach(directory => {
    const picker = directory.querySelector('.directory-picker');
    const select = directory.querySelector('[data-industry-select]');
    const groups = [...directory.querySelectorAll('[data-industry]')];
    const results = directory.querySelector('.directory-groups');
    const count = directory.querySelector('.directory-count');
    if (!picker || !select || !results || !count || !groups.length) return;

    const showIndustry = industry => {
      const valid = groups.some(group => group.dataset.industry === industry);
      select.value = valid ? industry : '';
      let total = 0;
      groups.forEach(group => {
        group.hidden = !valid || group.dataset.industry !== industry;
        if (!group.hidden) total += group.querySelectorAll('.provider-entry').length;
      });
      results.hidden = !valid;
      count.hidden = !valid;
      count.textContent = !valid ? '' : total === 1
        ? count.dataset.countSingular
        : count.dataset.countTemplate.replace('{count}', String(total));
    };

    const revealHashTarget = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); }
      catch { return; }
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !directory.contains(target)) return;
      const group = target.closest('[data-industry]');
      if (!group) return;
      showIndustry(group.dataset.industry);
      const entry = target.closest('.provider-entry');
      if (entry) entry.open = true;
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
    };

    showIndustry('');
    picker.hidden = false;
    select.addEventListener('change', () => showIndustry(select.value));
    window.addEventListener('hashchange', revealHashTarget);
    revealHashTarget();
  });
})();
